export default __webpack_public_path__ + "static/media/it900-a32-1.944abe6b.jpg";